
















import Vue from 'vue'
import style from './style.module.scss'

import textInput from '@/components/controls/text-input/text-input.vue'

import { debounce } from 'lodash'

export default Vue.extend({
name: 'url-zone',
  components: {
    textInput
  },
  props: {

  },
  mounted() {
    this.vm = this;
  },
  data() {
    return {
      s: style,
      url: '',
      vm: {} as Vue
    }
  },
  methods: {
    debounce,
    upload: debounce((url: string, vm: Vue) => {
      if(url) {
        vm.$emit('upload', url)
      }
    }, 800)
  }
  
})
